import config from 'config'

export const getHTJ2SystemAuthorizationUrl = () => {
	if (config.htj2.useTestEnv) {
		// TODO: Some of this documentation could be moved to the docs folder instead

		// NOTE: If testing with the test URL, you need to have setup a test
		// header htj-development-access-key to equal to the one provided by
		// MML for you personally. Refer to their docs for more info (or ask
		// someone who has worked on this code before).
		// The header can be added using the ModHeader Chrome extension.

		// NOTE:
		// For testing "henkilöisännöitsijä" or user manager's, you can use the
		// id 200448-999R in the test authorization
		// For other contexts the default autosuggeted one is sufficient

		return 'https://jarjestelmalupa-koe.nls.fi'
	} else {
		return 'https://jarjestelmalupa.nls.fi'
	}
}
